<div class="p-3">

    <div class="d-flex flex-row justify-content-between align-items-center mb-3">
        <h2 class="mb-0">Domain Management</h2>
        <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'domain-management', 'form']">Add
            Domain</button>
    </div>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>No</th>
                <th>Domain</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let domain of domains; let i = index">
                <td valign="middle">{{i + 1}}</td>
                <td valign="middle">{{domain.domain}}</td>
                <td valign="middle">{{domain.status == 1 ? 'Active' : 'Disabled'}}</td>
                <td valign="middle">
                    <div class="d-flex flex-row gap-2">
                        <a [routerLink]="['/lo', selected_company, 'domain-management', 'form', domain.uuid]"
                            class="btn btn-primary btn-sm">Edit</a>
                        <a [routerLink]="['/lo', selected_company, 'domain-management', 'setup', domain.uuid]"
                            class="btn btn-warning btn-sm">Setup</a>
                        <button class="btn btn-danger btn-sm" (click)="delete(domain.uuid)"
                            *ngIf="!domain.is_default">Delete</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>